<template>
  <div class="container">
    <Spinner class="mb-5"> Validating addresses... </Spinner>
    <div class="text-center">
      Our system is validating the addresses for the assignment, it may take up to a minute. This page will be
      automatically refreshed once the validation is complete.
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import Spinner from '@/views/Components/Loaders/Spinner.vue'

export default defineComponent({
  name: 'BatchCreatingItems',
  components: { Spinner },
})
</script>
